import { createContext, useContext } from 'react';

import { type Appearance, DEFAULT_APPEARANCE } from './accents';

export interface AppearanceContextValue {
  /** Apparence affichée (aperçu en cours ou réglage enregistré). */
  appearance: Appearance;
  /** Réglage enregistré pour tous les postes. */
  saved: Appearance;
  clinicName: string;
  /** Aperçu immédiat pendant le réglage ; `null` revient au réglage enregistré. */
  setPreview: (value: Appearance | null) => void;
}

export const AppearanceContext = createContext<AppearanceContextValue>({
  appearance: DEFAULT_APPEARANCE,
  saved: DEFAULT_APPEARANCE,
  clinicName: '',
  setPreview: () => undefined,
});

export function useAppearance() {
  return useContext(AppearanceContext);
}
